import Vue from 'vue';
import Notifications from '@/plugins/graphql/queries/v2/notifications.gql';
import NewNotificationSubscription from '@/plugins/graphql/subscriptions/v2/notification-created.gql';
import { NotificationModel } from '@/helpers/entities/models/NotificationModel';
import { groupBy } from 'lodash';
import { toCalendarTime } from '@/helpers/CalendarTime';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
export default Vue.extend({
    mixins: [RouterParamsAppMixin],
    apollo: {
        notifications: {
            query: Notifications,
            variables() {
                return {
                    appUuid: this.appUuid,
                    first: this.perPage,
                };
            },
            update(data) {
                const notifications = data.notifications.edges;
                const notificationsNode = (notification) => {
                    return new NotificationModel(notification.node);
                };
                return notifications.map(notificationsNode);
            },
            result({ data }) {
                this.pageInfo = data.notifications.pageInfo;
            },
            subscribeToMore: {
                document: NewNotificationSubscription,
                variables() {
                    return {
                        appUuid: this.baseAppUUID,
                        first: this.perPage,
                    };
                },
                updateQuery: (previousResult, { subscriptionData }) => {
                    const newNotif = subscriptionData.data.notificationCreate;
                    const { category } = newNotif;
                    previousResult.notifications.edges.unshift({
                        node: newNotif,
                        __typename: 'NotificationEdge',
                    });
                    this.$store.commit('navigation_drawer/showMayaReminder', true);
                    return previousResult;
                },
            },
        },
    },
    props: {
        appUuid: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            notifications: null,
            pageInfo: {
                startCursor: '',
                endCursor: '',
                hasNextPage: false,
                hasPreviousPage: false,
            },
            endCursor: null,
        };
    },
    computed: {
        perPage() {
            return 20;
        },
        groupedNotifications() {
            const { notifications } = this;
            if (notifications) {
                return groupBy(notifications, (notification) => {
                    return toCalendarTime(notification.createdAt);
                });
            }
            return {};
        },
        queryOnFlight() {
            return this.$apollo.queries.notifications.loading;
        },
        hasNotifications() {
            const { notifications } = this;
            return !!notifications && notifications.length !== 0;
        },
    },
    methods: {
        /**
         * Notification Paginator
         * Paginate Notifications and merge records for infinite scrolling
         * @author Peter John Alvarado <peterjohn@gorated.ph>
         * @since Version {0.10.0}
         *
         * @return {void}
         */
        fetchMore() {
            const { hasNextPage, endCursor } = this.pageInfo;
            if (hasNextPage) {
                this.$apollo.queries.notifications.fetchMore({
                    variables: {
                        first: this.perPage,
                        endCursor,
                    },
                    updateQuery: (previousNotificationsResult, { fetchMoreResult }) => {
                        const { notifications } = previousNotificationsResult;
                        const newNotifications = fetchMoreResult.notifications;
                        const mergedNotifications = [...notifications.edges, ...newNotifications.edges];
                        const { hasNextPage: newQueryHasNextPage, endCursor: newQueryEndCursor, } = newNotifications.pageInfo;
                        return {
                            notifications: {
                                ...notifications,
                                edges: mergedNotifications,
                                pageInfo: {
                                    ...notifications.pageInfo,
                                    hasNextPage: newQueryHasNextPage,
                                    endCursor: newQueryEndCursor,
                                },
                            },
                        };
                    },
                });
            }
        },
    },
    render() {
        if (this.$scopedSlots.default) {
            return this.$scopedSlots.default({
                notifications: this.notifications,
                groupedNotifications: this.groupedNotifications,
                queryOnFlight: this.queryOnFlight,
                hasNotifications: this.hasNotifications,
                fetchMore: this.fetchMore,
            });
        }
    },
});
